import React from 'react'
import '../Styles/JuniorCampPage3.scss';
import line from "../Images/Asset 1.png"
import { Link } from 'react-router-dom';

function JuniorCampPage3() {
   return (
      <div className="juniorCampPage3Content">
         <div className="juniorCampPage3Container">
            <div className="juniorCampPage3Heading">
               Registration Information
            </div>
            <div className="juniorCampPage3HeadingSubtext">
               Register for Camp Online in Three Simple Steps!
            </div>
            <div className="juniorCampPage3Numbers">
               <div className="regNumber1">
                  <h1 className="regNumber">1<br></br></h1>

                  <h4 className="regText">     Sign Up for or Sign <br></br>
                     Into An Individual Account<br></br></h4>
               </div>
               <div className="arrowOne">
                  <img className="regLine" src={line} alt=""></img>
               </div>
               <div className="regNumber2">
                  <h1 className="regNumber"> 2    <br></br></h1>
                  <h4 className="regText">Select "Register <br></br>
                     for a new event"</h4>
               </div>
               <div className="arrowTwo">
                  <img className="regLine" src={line} alt=""></img>
               </div>
               <div className="regNumber3">
                  <h1 className="regNumber">3<br></br></h1>
                  <h4 className="regText">Fill out and submit <br></br>
                     your registration <br></br>
                     information</h4>
               </div>
               <div className="arrowThree">
                  <img className="regLine" src={line} alt=""></img>
               </div>
               <div className="juniorCampPage3RegisterButton">
                  Register

                  <Link to={"/selectregistration"}>
                     <button>Register
                     </button>
                  </Link>
               </div>

            </div>

         </div>

      </div>
   )
}
export default JuniorCampPage3;